import { FaFireAlt } from "react-icons/fa";

export const StreakChip = ({ streak }: { streak: number }) => {
  return (
    <div
      className="text-warning text-2xl flex flex-row justify-center items-center gap-1 active:opacity-50"
      style={{
        color: streak > 0 ? "#FFA500" : "#777777",
      }}
    >
      <FaFireAlt className="" />
      <p className="font-chewy leading-none">{streak}</p>
    </div>
  );
};
